/* eslint-disable */
import qs from 'qs';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, ControlLabel, Form, FormGroup, FormControl } from 'react-bootstrap';
import { NotificationManager } from 'react-notifications';

import changeCase from 'change-object-case';
import { ss, adminBecome, setToken, newOrder, tokenLogin, ok, navTo } from '../utils/util';
import Wrapper from './Wrapper';
import {
} from '../actions';


class OauthGoogle extends Component {
  render() {
    let query = window.location.hash.slice(1);
    let params = qs.parse(query);
    console.log('query', params);
    return (
      <Wrapper>
        One moment...
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OauthGoogle);



/** WEBPACK FOOTER **
 ** ./src/components/OauthGoogle.js
 **/